import type { ConformanceTarget } from './accessabilityData';
import type { OffsetPaginatedResponse } from './pagination';

/**
 * Fields by which the home-domain overview can be ordered. Each is a stored
 * column; the report-derived values (score, average error count, page count)
 * are only sortable in the browser, once a small set has been fetched whole.
 */
export const HOME_DOMAIN_SORT_FIELDS = ['domain', 'conformanceTarget'] as const;

export type HomeDomainSortField = (typeof HOME_DOMAIN_SORT_FIELDS)[number];
export type HomeDomainSortDirection = 'asc' | 'desc';

/** Public query options accepted by the home-domain endpoint. */
export interface HomeDomainsRequest {
  limit?: number;
  offset?: number;
  search?: string;
  pinnedOnly?: boolean;
  conformanceTargetLevels?: string[];
  sortBy?: HomeDomainSortField;
  sortDirection?: HomeDomainSortDirection;
}

/** One domain row returned by the home-domain endpoint. */
export interface HomeDomainData {
  id: number;
  domain: string;
  domainAlias: string | null;
  isPinned: boolean;
  conformanceTarget: ConformanceTarget;
  summaryDetailScore?: string;
  lastAvgErrorCount?: string;
  lastTotalPagesChecked?: number;
}

/** Response contract shared by the API and dashboard. */
export type HomeDomainsResponse = OffsetPaginatedResponse<HomeDomainData>;
